import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { isUserLoggedIn, updateCartAction } from './actions';
import './App.css';
import CartPage from './containers/CartPage';
import CheckoutPage from './containers/CheckoutPage';
import HomePage from './containers/HomePage';
import OrderDetailsPage from './containers/OrderDetailsPage';
import OrderPage from './containers/OrderPage';
import ProductDetailsPage from './containers/ProductDetailsPage';
import ProductListPage from './containers/ProductListPage';
import PrivateRoute from './components/HOC/PrivateRoute';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
	const dispatch = useDispatch();
	const auth = useSelector((state) => state.auth);
	const product = useSelector(state => state.product);

	
	useEffect(
		() => {
			if (!auth.authenticate) {
				dispatch(isUserLoggedIn());
			}

		},
		[ auth.authenticate ]
	);


	useEffect(
		() => {
			dispatch(updateCartAction());
		},
		[ auth.authenticate ]
	);



	return (
		<div className="App">
			<ErrorBoundary>
			<Router>
				<Switch>
					<Route path="/" exact component={HomePage} />
					<Route path="/cart" component={CartPage} />
					<PrivateRoute path="/checkout" component={CheckoutPage} />
					<PrivateRoute path="/account/orders" component={OrderPage} />
					<PrivateRoute path="/order_details/:orderId" component={OrderDetailsPage} />
					<Route path="/:productSlug/:productId/p" component={ProductDetailsPage} />
					<Route path="/:slug" component={ProductListPage} />
				</Switch>
			</Router>
			</ErrorBoundary>
		</div>
	);
}

export default App;
